import React from "react";

import styled from "../../theme/styled";
import {
  colourHelper,
  fontLineHeightHelper,
  fontSizeHelper,
  fontSpaceHelper,
  fontWeightHelper
} from "../../theme/theme-helper";
import { SmallColumnWidthWrapper } from "../confines-wrappers";
import Link from "../link";
import Wysiwyg from "../wysiwyg";
import {
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type?: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

const ParagraphTextBoxOutContainer = styled.div`
  * {
    transform: 0.2s ease-in-out;
    text-align: center;
  }

  .content-container {
    background: ${({ theme }) =>
    colourHelper({
      theme,
      variant: "lightestGrey"
    })};

    h2 {
      margin: 0;
      padding: 0;
      color: ${({ theme }) => colourHelper({
    theme,
    variant: "brandColor"
  })};
      font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "body_1"
  })};
      font-weight: ${({ theme }) =>
    fontWeightHelper({
      theme,
      variant: "bold"
    })};
      line-height: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "normalized"
    })};
      letter-spacing: ${({ theme }) =>
    fontSpaceHelper({
      theme,
      variant: "medium"
    })};
      text-transform: uppercase;
    }

    p {
      transform: 0.2s ease-in-out;
      margin-bottom: 0;
      padding-top: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "small"
    })};
      font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "body_2"
  })};
      font-weight: ${({ theme }) =>
    fontWeightHelper({
      theme,
      variant: "bold"
    })};
      line-height: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "default"
    })};

      &.more-link {
        padding-top: 5.8rem;
        font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "small_3"
    })};
      }
    }
  }

  @media (min-width: 480px) {
    .content-container {
      p {
        font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "subhead_1"
    })};
      }
    }
  }

  @media (min-width: 600px) {
    .content-container {
      p {
        font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "subhead_2"
    })};

        &.more-link {
          padding-top: 7.2rem;
          font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "body_1"
    })};
        }
      }
    }
  }

  @media (min-width: 960px) {
    .content-container {
      h2 {
        font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "body_2"
    })};
      }

      p {
        font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "subhead_3"
    })};

        &.more-link {
          padding-top: 8.8rem;
          font-size: ${({ theme }) =>
    fontSizeHelper({
      theme,
      variant: "body_2"
    })};
        }
      }
    }
  }
`;

const ParagraphTextBoxOut = ({ content }: IProps) => {
  const {
    field_boxout_header, field_boxout_text, field_boxout_link
  } = content;

  return (
    <ParagraphTextBoxOutContainer className="paragraph-box-out-text">
      <div className="content-container">
        <SmallColumnWidthWrapper>
          <h2>
            {field_boxout_header}
          </h2>

          {field_boxout_text && (
            <Wysiwyg
              type="formatted"
              content={field_boxout_text.processed}
            />
          )}

          {field_boxout_link &&
            field_boxout_link.uri &&
            field_boxout_link.title && (
              <p className="more-link">
                <Link
                  type="styled"
                  href={field_boxout_link.uri}
                >
                  {field_boxout_link.title}
                </Link>
              </p>
          )}
        </SmallColumnWidthWrapper>
      </div>
    </ParagraphTextBoxOutContainer>
  );
};

export default ParagraphTextBoxOut;
